import React, { useState } from 'react'
import classNames from 'classnames'
import Typography from '@toasttab/shared/src/components/atoms/Typography/Typography'
import AccordionItem from './AccordionItem/AccordionItem'
import { AccordionProps } from './Accordion.d'

const Accordion = ({
  bgColor,
  children = [],
  headingClasses,
  sectionHeading,
  textAlignment,
  toggleSwitch, // default Active
  toggleSwitch2 // shadow
}: AccordionProps) => {
  const [activeIndex, setActiveIndex] = useState(!toggleSwitch ? 0 : null)

  const toggleAccordion = (index: number) => {
    if (activeIndex === index) {
      setActiveIndex(null)
    } else {
      setActiveIndex(index)
    }
  }
  const renderAccordionItems = () => {
    return children?.map((accordionItem: any, index: number) => {
      return (
        <AccordionItem
          {...accordionItem}
          shadow={toggleSwitch2}
          bgColor={bgColor}
          isActive={activeIndex === index}
          onClick={() => toggleAccordion(index)}
          key={index}
          itemNumber={index + 1}
        />
      )
    })
  }

  const headingCss = classNames(
    'pl-4 pt-12 text-default',
    `text-${textAlignment}`,
    headingClasses
  )

  return (
    <div data-testid='accordion' role='tablist' aria-label={sectionHeading}>
      {sectionHeading && (
        <Typography as='h3' classes={headingCss} variation='h3'>
          {sectionHeading}
        </Typography>
      )}
      <div className='pt-8'>{renderAccordionItems()}</div>
    </div>
  )
}

export default Accordion
